/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Application_IdInputs */

const en_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application ID`)
};

const fr_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID d'application`)
};

const de_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwendungs-ID`)
};

const it_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID applicazione`)
};

const ru_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор приложения`)
};

const es_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de la aplicación`)
};

const zh_cn2_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用程序 ID`)
};

const ja_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリケーションID`)
};

const hi_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवेदन आईडी`)
};

const pt_pt2_options_integrations_application_id = /** @type {(inputs: Options_Integrations_Application_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do aplicativo`)
};

/**
* | output |
* | --- |
* | "Application ID" |
*
* @param {Options_Integrations_Application_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_application_id = /** @type {((inputs?: Options_Integrations_Application_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Application_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_integrations_application_id(inputs)
	if (locale === "de") return de_options_integrations_application_id(inputs)
	if (locale === "it") return it_options_integrations_application_id(inputs)
	if (locale === "ru") return ru_options_integrations_application_id(inputs)
	if (locale === "es") return es_options_integrations_application_id(inputs)
	if (locale === "zh-CN") return zh_cn2_options_integrations_application_id(inputs)
	if (locale === "ja") return ja_options_integrations_application_id(inputs)
	if (locale === "hi") return hi_options_integrations_application_id(inputs)
	if (locale === "pt-PT") return pt_pt2_options_integrations_application_id(inputs)
	return en_options_integrations_application_id(inputs)
});